/**
 * This is using the naming defined by Adobe Acrobat
 *
 * Possible values:
 * - SinglePage
 * - OneColumn
 * - TwoColumnLeft
 * - TwoColumnRight
 * - TwoPageLeft
 * - TwoPageRight
 *
 * */
export var PdfViewerLayoutType;
(function (PdfViewerLayoutType) {
    PdfViewerLayoutType["SinglePage"] = "SinglePage";
    PdfViewerLayoutType["OneColumn"] = "OneColumn";
})(PdfViewerLayoutType || (PdfViewerLayoutType = {}));
//# sourceMappingURL=pdf-viewer-layout.type.js.map